export default {
      id: "stop-usage",
      viewBox: "0 0 120 120",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#stop",
      toString: function () {
        return this.url;
      }
    }